import polyfillClosest from "../polyfill";
import header from "Components/turnbull/header/header";
import navigation from "Components/turnbull/navigation/navigation";
import cookieBanner from "Components/turnbull/cookie/mando-ui.cookie";
import table from "Components/turnbull/_rte-table/mando-ui.rte-table";

import heroCarousel from "Components/turnbull/hero/mando-ui.hero-carousel";
import person from "Components/turnbull/person/person";

document.addEventListener("DOMContentLoaded", () => {
  // Add JS helper class
  document.getElementsByTagName("html")[0].classList.remove("no-js");
  document.getElementsByTagName("html")[0].classList.add("has-js");

  //* Polyfill
  polyfillClosest();

  // Components
  header();
  navigation();
  cookieBanner();
  heroCarousel();
  person();
  table();
});



// WEBPACK FOOTER //
// ./src/scripts/brands/turnbull.js